module.exports = __webpack_public_path__ + "static/img/4.ef15083.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos-en/4.jpg
// module id = d7h+
// module chunks = 0